'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appLogger = undefined;

var _logger = require('@getgo/logger');

var _logger2 = _interopRequireDefault(_logger);

var _loggerTargetLoggingService = require('@getgo/logger-target-logging-service');

var _loggerTargetLoggingService2 = _interopRequireDefault(_loggerTargetLoggingService);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _config = require('../../../config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configuration = void 0;

// -------------------------------------------------------------- CONFIGURATION --------------------------------------------------------------

var config = function config() {
  return !configuration ? _config.Configuration.getConfig() : configuration;
};

var loggerTargetLoggingService = function loggerTargetLoggingService() {
  (0, _loggerTargetLoggingService2.default)({

    server: '' + config().logger.url,
    context: {
      ls_source: '' + config().logger.source,
      ls_sourcetype: 'logging'
    }
  });
};

var appLogger = function appLogger() {
  var reqLogger = _logger2.default.createRoot(loggerTargetLoggingService());
  reqLogger.setContext('uuid', _uuid2.default.v4());
  reqLogger.setContext('machineId', _uuid2.default.v4());

  return reqLogger;
};

exports.appLogger = appLogger;


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/lib/app/logging.js
// module id = 752
// module chunks = 0